import { OrbitControls } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { useEffect, useRef } from 'react';

export const ThreeUtilityGetter = (props) => {
  props ??= {};
  const { setRenderer, setScene, setCamera, setOrbitControls } = props;
  const { gl, scene, camera } = useThree();
  const orbitRef = useRef(null);

  useEffect(() => {
    if (setRenderer) setRenderer(gl);
    if (setScene) setScene(scene);
    if (setCamera) setCamera(camera);
  }, [gl, scene, camera, setRenderer, setScene, setCamera, setOrbitControls]);

  return <OrbitControls ref={orbitRef}></OrbitControls>;
};
